import { useState } from 'react';

import ChatbotContent from '../ChatbotContent/ChatbotContent';
import ChatbotProvider, { EAgentName, EChatbotVariant } from '../ChatbotProvider';
import HomePageButton from './HomePageButton';
import SearchPageButton from './SearchPageButton';

type TChatbotContainerProps = {
  variant: EChatbotVariant;
};

export interface TChatbotButtonProps {
  handleOpen: () => void;
}

const ChatbotContainer = ({ variant }: TChatbotContainerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  if (variant === EChatbotVariant.SRP) {
    return (
      <div className="flex flex-row items-center justify-center gap-4 md:pr-4 md:border-r md:border-neutral-20">
        <SearchPageButton handleOpen={handleOpen} />

        <div className="fixed bottom-8 right-8 z-1299">
          <ChatbotProvider
            open={isOpen}
            onClose={handleClose}
            agentName={EAgentName.TRIP_PLANNER}
            variant={EChatbotVariant.SRP}>
            <ChatbotContent />
          </ChatbotProvider>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 xl:flex-row">
      <HomePageButton handleOpen={handleOpen} />

      <div className="fixed bottom-8 right-8 z-1299">
        <ChatbotProvider
          open={isOpen}
          onClose={handleClose}
          agentName={EAgentName.TRIP_PLANNER}
          variant={EChatbotVariant.HOME}>
          <ChatbotContent />
        </ChatbotProvider>
      </div>
    </div>
  );
};

export default ChatbotContainer;
